module.exports = __webpack_public_path__ + "static/media/3DPPA1.4c05f6c8.jpg";